module.exports = __webpack_public_path__ + "static/media/Images_DJReadyRoc.4e5ee0d8.jpeg";